var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 57,
    viewBox: "0 0 64 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_471_229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49 14.4262C47.7222 14.9437 46.3708 15.2859 44.988 15.442C46.4469 14.6282 47.5402 13.3481 48.065 11.8389C46.694 12.6009 45.1933 13.1378 43.628 13.4262C42.5817 12.3668 41.1884 11.6616 39.6667 11.4213C38.1449 11.1809 36.5807 11.4189 35.2194 12.098C33.8582 12.777 32.7768 13.8588 32.1449 15.1735C31.513 16.4882 31.3664 17.9616 31.728 19.3625C28.956 19.2316 26.2446 18.5577 23.7697 17.3846C21.2949 16.2114 19.112 14.5653 17.363 12.5532C16.7495 13.5534 16.4272 14.6862 16.428 15.8388C16.4258 16.9092 16.7072 17.9635 17.247 18.9078C17.7868 19.8522 18.5683 20.6572 19.522 21.2513C18.4136 21.2232 17.3288 20.9454 16.36 20.4418V20.5212C16.3683 22.0209 16.9312 23.472 17.9534 24.6289C18.9757 25.7858 20.3945 26.5775 21.97 26.8702C21.3635 27.0425 20.7339 27.1333 20.1 27.14C19.6612 27.1352 19.2235 27.098 18.791 27.0289C19.2396 28.319 20.1079 29.4465 21.2748 30.2544C22.4418 31.0623 23.8495 31.5105 25.302 31.5367C22.8492 33.3386 19.821 34.322 16.7 34.3302C16.1317 34.3319 15.564 34.3001 15 34.235C18.1865 36.1559 21.9 37.1757 25.693 37.1714C28.3105 37.1968 30.9071 36.7349 33.3313 35.8128C35.7555 34.8907 37.9585 33.5269 39.8118 31.8009C41.6652 30.075 43.1315 28.0215 44.1253 25.7605C45.1192 23.4995 45.6205 21.0763 45.6 18.6324C45.6 18.3625 45.6 18.0768 45.6 17.7911C46.934 16.8623 48.0845 15.7236 49 14.4262Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_471_229",
    x: 0,
    y: 0.330078,
    width: 64,
    height: 55.8423,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_471_229"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_471_229",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterSmall);
export default __webpack_public_path__ + "static/media/twitterSmall.1c2b6589.svg";
export { ForwardRef as ReactComponent };